import React from 'react'
import { Link } from 'react-router-dom'
import { useLocale } from '../contexts/LocaleContext'

function LanguageSwitcher() {
  const { locale } = useLocale()

  return (
    <div className="language-switcher">
      <Link
        className={`lang-btn ${locale === 'en' ? 'active' : ''}`}
        to="/"
        hrefLang="en"
        aria-label="Switch to English"
      >
        EN
      </Link>
      <span className="separator">|</span>
      <Link
        className={`lang-btn ${locale === 'fr' ? 'active' : ''}`}
        to="/fr"
        hrefLang="fr"
        aria-label="Passer en français"
      >
        FR
      </Link>
    </div>
  )
}

export default LanguageSwitcher
